import React from 'react';

type ModalInlineNoticeTone = 'neutral' | 'info' | 'warning' | 'success';

interface ModalInlineNoticeProps {
  message: React.ReactNode;
  action?: React.ReactNode;
  tone?: ModalInlineNoticeTone;
  style?: React.CSSProperties;
  className?: string;
}

const ModalInlineNotice: React.FC<ModalInlineNoticeProps> = ({
  message,
  action,
  tone = 'neutral',
  style,
  className,
}) => {
  const resolvedClassName = [
    'modal-inline-notice',
    tone !== 'neutral' ? `modal-inline-notice--${tone}` : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={resolvedClassName} style={style}>
      <div className="modal-inline-notice__message">{message}</div>
      {action ? <div className="modal-inline-notice__action">{action}</div> : null}
    </div>
  );
};

export default ModalInlineNotice;
